import { fetchGet } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'

export const apiFetchTopics = async (phone) => {
  const suggestedApiUrl = await getParam('suggestedContentApiUrl')

  return fetchGet(`${suggestedApiUrl}/trending_content`, { phone, count: 10 })
}
